import { call, fork, put, take } from 'redux-saga/effects';
import {Api} from '../api';
import {Asset} from '../api/types';
import {FetchDepotAssetsPayload, fetchDepotAssets} from '../action/depotsCommands';
import {depotAssetsFetched} from '../action/depotsEvents';
import {Action} from 'redux-actions';
import {enqueueWarningSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import Logger from '../common/logger';

export const onFetchDepotAssets = function*(depotId: string) {
    try {
        const assets: Asset[] = yield call(Api.getDepotAssets, depotId);

        yield put(depotAssetsFetched({ depotId, assets }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueWarningSnackbar({ message: getI18n().t('snackbar.warning.fetch_depot_assets') }));
    }
};

export function* fetchDepotAssetsFlow() {
    while (true) {
        const action: Action<FetchDepotAssetsPayload> = yield take(fetchDepotAssets.toString());

        // eslint-disable-next-line no-console
        console.log('fetchDepotAssetsFlow', fetchDepotAssets.toString());
        
        yield fork(onFetchDepotAssets, action.payload.depotId);
    }
}
